import { useLicenseContext, useLicenseFeatureFlag } from "@tldraw/editor";
function useCommentingEnabled() {
  return useLicenseFeatureFlag(useLicenseContext(), "commenting");
}
export {
  useCommentingEnabled
};
//# sourceMappingURL=useCommentingEnabled.mjs.map
